import { Injectable } from '@angular/core'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { ModalPositionService } from '../../../services/modal-position.service'
import { UpdateDescriptionModalComponent } from './update-description-modal.component'

@Injectable()
export class UpdateDescriptionModalService {
  constructor(
    private readonly modalService: NgbModal,
    private readonly modalPositionService: ModalPositionService,
  ) {}

  toggle(
    description: string,
    modalTitle: DescriptionModalTitles,
  ): Promise<string> {
    const compKey = 'hot-keys-help'
    const uniqueId = compKey + '-' + Date.now()
    const modalRef = this.modalService.open(UpdateDescriptionModalComponent, {
      size: 'md',
      keyboard: false,
      windowClass: uniqueId,
      beforeDismiss: () => {
        return this.modalPositionService.handleModalPositionSaveOnDismiss(
          uniqueId,
          compKey,
        )
      },
    })
    const component =
      modalRef.componentInstance as UpdateDescriptionModalComponent
    component.description = description
    component.modalTitle = modalTitle
    this.modalPositionService.handleModalPositionSetup(uniqueId, compKey)
    return modalRef.result
  }
}

export enum DescriptionModalTitles {
  FilterGroup = 'Update Filter Group Description',
  Workspace = 'Update Workspace Description',
}
